import { render, staticRenderFns } from "./All.vue?vue&type=template&id=ef4d7c4e&scoped=true"
import script from "./All.vue?vue&type=script&lang=ts"
export * from "./All.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4d7c4e",
  null
  
)

export default component.exports